import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setAddressesAction,
  updateAddressAction,
  setAddressesStatusAction,
  setAddressesErrorsAction,
  clearAddressesErrorsAction
} from './addresses.actions'

export const fetchAddresses = () => async dispatch => {
  try {
    dispatch(setAddressesStatusAction('loading'))
    dispatch(clearAddressesErrorsAction())

    const { data } = await branditRails.get('/addresses')

    dispatch(setAddressesAction(data))
    dispatch(setAddressesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setAddressesErrorsAction({ message: errorMessage }))
    dispatch(setAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updateAddress = (addressId, addressData) => async dispatch => {
  try {
    dispatch(setAddressesStatusAction('loading'))
    dispatch(clearAddressesErrorsAction())

    const { data } = await branditRails.patch(`/addresses/${addressId}`, addressData)

    dispatch(updateAddressAction(data))
    dispatch(setAddressesStatusAction('succeeded'))
    toastr.success('Address', 'Address updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setAddressesErrorsAction({ message: errorMessage }))
    dispatch(setAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const validateAddress = addressData => async dispatch => {
  try {
    dispatch(setAddressesStatusAction('loading'))
    dispatch(clearAddressesErrorsAction())

    const { data } = await branditRails.post('/addresses/validate', addressData)

    dispatch(setAddressesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setAddressesErrorsAction({ message: errorMessage }))
    dispatch(setAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
